import { useSessionContext } from "../state/SessionContext";

export function useSession() {
  return useSessionContext();
}